export default __webpack_public_path__ + "static/media/close.3e141cd0.svg";